<!--
 * @Author: your name
 * @Date: 2020-09-08 09:37:08
 * @LastEditTime: 2022-10-20 17:19:05
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ConcreteCloud.Mobile\src\views\salesTerminal\blockRegister\blockList.vue
-->
<template>
    <div class="accountConfirm-blockList">
        <van-nav-bar
            title="试块列表"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
        ></van-nav-bar>
        <van-pull-refresh
            v-model="isLoading"
            @refresh="onRefresh"
        >
            <template>
                <div class="warpper">
                    <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                    >
                        <div
                            class="materialPlan-item"
                            v-for="(item,index) in orderList"
                            :key="index"
                            @click="toEdit(item)"
                        >
                            <ul>
                                <li class="tit">
                                    <span class="iconfont icondanjubianhao"></span>
                                    <span class="info">试块试验编号：{{ item.testblock_number }}</span>
                                </li>
                                <li>
                                    <span class="pre-icon">
                                        <img src="@/assets/images/icons/icon_gy_1.png">
                                    </span>
                                    <span class="info">施工部位：{{ item.place_name }}</span>
                                </li>
                                <li>
                                    <span class="pre-icon">
                                        <img src="@/assets/images/icons/icon_3.png">
                                    </span>
                                    <span class="info">强度等级：{{ item.strength_grade_name }}</span>
                                </li>
                                <li>
                                    <span class="pre-icon">
                                        <img src="@/assets/images/icons/icon_gy_2.png">
                                    </span>
                                    <span class="info">实测值：{{ item.measured }}</span>
                                </li>
                                <li>
                                    <van-row>
                                        <van-col span="12">
                                            <span class="pre-icon">
                                                <img src="@/assets/images/icons/icon_gy_8.png">
                                            </span>
                                            <span class="info">龄期：{{ item.instar }}</span>
                                        </van-col>
                                        <van-col span="12">
                                            <span class="pre-icon">
                                                <img src="@/assets/images/icons/icon_30.png">
                                            </span>
                                            <span class="info">试块规格(mm)：{{ item.block_model }}</span>
                                        </van-col>
                                    </van-row>
                                </li>
                                <li>
                                    <span class="pre-icon">
                                        <img src="@/assets/images/icons/icon_6.png">
                                    </span>
                                    <span class="info">委托单位：{{ item.entrustingparty }}</span>
                                </li>
                                <li>
                                    <span class="pre-icon">
                                        <img src="@/assets/images/icons/icon_32.png">
                                    </span>
                                    <span class="info">制作人：{{ item.maker }}</span>
                                </li>
                                <li>
                                    <span class="pre-icon">
                                        <img src="@/assets/images/icons/icon_gy_7.png">
                                    </span>
                                    <span class="info">制作时间：{{ item.make_time }}</span>
                                </li>
                            </ul>
                        </div>
                    </van-list>
                </div>
            </template>
        </van-pull-refresh>
    </div>
</template>

<script>
export default {
    name: 'block-register-childlist',
    beforeRouteLeave(to, from, next) {
        if (to.path === '/blockRegisterList') {
            this.keywords = '';
            this.$store.commit('noKeepAlive', 'block-register-childlist');
        }
        next();
    },
    components: {},
    props: {},
    data() {
        return {
            orderList: [],
            loading: false,
            finished: false,
            page: {
                pageindex: 0,
                pagesize: 3,
            },
            // 下拉刷新
            isLoading: false,
            task_number: '',
            formula_number: '',
        };
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {
        this.task_number = this.$route.params.data.task_number || this.task_number;
        this.formula_number = this.$route.params.data.product_formula_number || this.formula_number;
    },
    methods: {
        // 返回
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 编辑
        toEdit(data) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'editBlock', params: { data: data } });
        },
        // 下拉刷新
        onRefresh() {
            this.page.pageindex = 0;
            this.finished = false;
            this.loading = true;
            this.onLoad();
        },
        onLoad() {
            if (this.isLoading) {
                this.orderList = [];
                this.isLoading = false;
            }
            this.page.pageindex += 1;
            this.getListPage();
        },
        async getListPage() {
            const res = await this.getListApi();
            if (res) {
                this.showOverlay = false;
                this.loading = false;
                this.isLoading = false;
                if (res.total) {
                    this.total = true;
                    this.orderList = this.orderList.concat(res.rows);
                    if (this.orderList.length >= res.total) {
                        this.finished = true;
                    }
                } else {
                    this.total = false;
                    this.finished = true;
                }
            }
        },
        getListApi() {
            const queryStr = '?task_number=' + this.task_number + '&formula_number=' + this.formula_number
            + '&pageindex=' + this.page.pageindex + '&pagesize=' + this.page.pagesize;
            return this.$axios.$get('/interfaceApi/production/formulablockpressure/query_block_task_list' + queryStr, { defEx: true });
        },
    },
};
</script>
<style lang="stylus">
.accountConfirm-blockList
    height 100%
    background #F0F0F0
    .van-pull-refresh
        height calc(100% - 45rpx)
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
        .van-pull-refresh__track
            height 100%
    .van-nav-bar
        .van-nav-bar__title
            div
                display inline-block
                padding 0 15rpx
                font-size 14rpx
                color rgba(240,240,240,0.7)
                transition 0.2s
                &.active
                    font-size 18rpx
                    color #fff
    .van-overlay
        .van-loading
            position absolute
            z-index 100
            top 50%
            left 50%
    .newPlan
        position fixed
        right 20rpx
        top 10rpx
        z-index 1000
        color #fff
    .search-con
        .van-search
            padding 15rpx 12rpx 15rpx 12rpx
    .van-pull-refresh__head
        background #F0F0F0
    .warpper
        // height 100%
        background #F0F0F0
        padding 12rpx 12rpx 12rpx 12rpx
        position relative
        .materialPlan-item
            width 100%
            background #ffffff
            margin-bottom 15rpx
            position relative
            overflow hidden
            // padding 16rpx
            color #666666
            font-size 14rpx
            .connect
                position absolute
                bottom 70rpx
                right 15rpx
                padding 5rpx 15rpx
                border 1px solid #5588F1
                border-radius 4rpx
                color #5588F1
            ul
                padding 16rpx 16rpx 5rpx 16rpx
                border-bottom 1px solid #F0F0F0
                li
                    overflow hidden
                    margin-bottom 10rpx
                    .pre-icon
                        width 16rpx
                        line-height 16rpx
                        float left
                        background-size 100% 100%
                        background-repeat no-repeat
                        display inline-block
                        margin 2rpx 10rpx 0 0
                        img
                            width 16rpx
                            vertical-align middle
                    .info
                        float left
                        width calc(100% - 26rpx)
                    &.tit
                        font-size 16rpx
                        .icondanjubianhao
                            color #3495FB
                            font-size 18rpx
                            margin 3rpx 8rpx 0 0
                            float left
    .warpper-zcx
        padding 12rpx 12rpx 12rpx 12rpx

</style>